import React from "react";
import { Helmet } from "react-helmet-async";

const Title = ({ title, content }) => {
  return (
    <div>
      <Helmet>
        <title>{title} - Mybestmart</title>
        <meta name={title} content={content} />
        <link rel="canonical" href="https://mybestmart.xyz" />
      </Helmet>
    </div>
  );
};

export default Title;
